import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["linkAs", "title"];
/* eslint-disable jsx-a11y/heading-has-content */

import React from 'react';
import { Button } from 'semantic-ui-react';
var ELEMENT_PROPS = {
  Button: {
    primary: true
  }
};
var ELEMENT_TYPES = {
  span: /*#__PURE__*/React.createElement("span", null),
  p: /*#__PURE__*/React.createElement("p", null),
  // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content
  a: /*#__PURE__*/React.createElement("a", null),
  Button: /*#__PURE__*/React.createElement(Button, null),
  h1: /*#__PURE__*/React.createElement("h1", null),
  h2: /*#__PURE__*/React.createElement("h2", null),
  h3: /*#__PURE__*/React.createElement("h3", null),
  h4: /*#__PURE__*/React.createElement("h4", null)
};

function getElementProps(linkAs) {
  return ELEMENT_PROPS[linkAs] || {};
}

function getLinkElement(linkAs) {
  return ELEMENT_TYPES[linkAs] || ELEMENT_TYPES.span;
}

export default (function (_ref) {
  var linkAs = _ref.linkAs,
      title = _ref.title,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.cloneElement(getLinkElement(linkAs), _extends({
    children: title
  }, getElementProps(linkAs), rest));
});